import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=1e804c98&scoped=true&lang=pug&"
import script from "./avatar.vue?vue&type=script&lang=ts&"
export * from "./avatar.vue?vue&type=script&lang=ts&"
import style0 from "./avatar.vue?vue&type=style&index=0&id=1e804c98&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e804c98",
  null
  
)

export default component.exports